<template>
	<button @click="onClick" type="button" :disabled="totalObjetos > 0 || !active">
		<i class="fas fa-trash-alt"></i>
	</button>
</template>
<script>
export default {
	name: 'ButtonAction',
	props: {
		onClick: {
			type: Function
		},
		totalObjetos: {
			type: Number,
			default: 0
		},
		active: {
			type: Boolean,
			default: true
		}
	}
}
</script>
<style lang="scss" scoped>
button {
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	border-radius: 5px;
	width: 28px;
	height: 28px;
	background-color: $danger-color;
	color:#fff;
	font-weight: $font-weight-default-bolder;
	font-size: $font-size;
	cursor: pointer;
	outline: none;

	&:hover {
		&:not(:disabled) {
			background-color:  $danger-color-darker;
		}
	}

	&:disabled {
		opacity: .3;
		cursor: default;
	}
}

</style>
